module.exports = __webpack_public_path__ + "static/media/business.dc65342c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/web/business.svg
// module id = 262
// module chunks = 0